// tslint:disable:object-literal-sort-keys
export const colors = {
  bar: "#343454",
  tick: "#EDEEF2",
  grey: "#EDEEF2",
  active: "#5A2CC9",
};
